import React, { useEffect, createElement } from 'react';
import { Landing } from './pages/Landing';
export function App() {
  useEffect(() => {
    // Microsoft Clarity
    const w = window as any;
    w.clarity = w.clarity || function () {
      ;
      (w.clarity.q = w.clarity.q || []).push(arguments);
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/wco1vnuokt';
    document.head.appendChild(script);
    return () => {
      // Cleanup on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <Landing data-id="element-0" />;
}